import { AuditEntity } from "@app/common";
import { Customer } from "@app/customers-base";
import { BillSource } from "@app/products-base";
import { Column, Common, Display, Table } from "@messaia/cdk";
import { BillStatus } from "../enums/bill-status";

@Table({
    endpoint: 'bill',
    includes: ['Customer'],
    selectable: false,
    deletable: false,
    editable: false
})
export class BillEmbedded extends AuditEntity {
    @Column({ name: 'customer.displayName', filter: 'customer.displayName' })
    @Display($localize`:@@customer:Customer`)
    customerId: number | null;
    customer: Customer;

    @Column({ width: 70, showGtLg: true })
    @Display($localize`:@@year:Year`)
    billYear: number;

    @Column({
        content: (row: BillEmbedded) => Common.months?.filter(x => x.id == row.billMonth)[0]?.name,
        options: Common.months,
        width: 70,
        showGtLg: true
    })
    @Display($localize`:@@month:Month`)
    billMonth: number;

    @Column({ enumType: BillSource, maxWidth: 85, showGtMd: true })
    @Display($localize`:@@source:Source`)
    source: BillSource = BillSource.Intern;

    @Column({ enumType: BillStatus, maxWidth: 80, showGtLg: true })
    @Display($localize`:@@status:Status`)
    status: BillStatus = BillStatus.Created;

    @Column({ filterOperator: '~', width: 90, showGtLg: true })
    @Display($localize`:@@billNr:Bill Nr.`)
    number: number;

    @Column({
        name: 'customer.number',
        filter: 'customer.number',
        filterOperator: '~',
        width: 90,
        showGtLg: true
    })
    @Display($localize`:@@customerNr:Customer Nr.`)
    customerNumber: number;

    name: string;

    path: string;
    itemizedBillPath: string;
}